export default "__VITE_ASSET__CRb0PpUn__"